<template>
  <div id="app">  
    <router-view/>  
     <Contact v-if="$conFun.clientWidth()>768"/>
  </div>
</template>
<script>
import Contact from './components/Contact.vue'
 export default {
        name:'index',      
        components:{Contact},
      }
</script>
<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  margin: 0;
}
.fotter{
  height:300px;
  background:#ccc;
  margin-top:50px
}
.fotter .flex{
   justify-content: space-between;
}

.fotter .flex .f16{
   line-height:32px
}
.fotter .about{
  text-align:center;
  color:#333;
  font-size:24px;
  padding:40px 0
}
</style>



// WEBPACK FOOTER //
// src/App.vue